import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useEffect} from "react";
import axios from "axios"; // To make API calls
import Select from "react-select";
import API_URL from "../../src/Config";
function TemplateApiEndPoint({isSidebarExpanded}) {
  const [permitTypeId, setPermitTypeId] = useState("");
  const [method, setMethod] = useState("");
  const [apiEndpoint, setApiEndpoint] = useState("");
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState(""); // for error or success feedback
  const [permitType, setPermitType] = useState([]);
  const [selectedPermitType, setSelectedPermitType] = useState(null);
  // Handle form submission
  const methodOptions = [
    { value: "GET", label: "GET" },
    { value: "POST", label: "POST" },
    { value: "PUT", label: "PUT" },
    { value: "DELETE", label: "DELETE" },
  ];

  const [formData, setFormData] = useState({
    permit_type_id: "",
    method: "",
    api_endpoint: "",
  });
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    //   handleSaveClick();
    }
  };
  
  const fetchPermitType = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/get_work_permit_types`, {
        headers: {
          Authorization: authKey,
        },
      });

      const permitTypeOptions = response.data.work_permit_types.map(
        (permitType) => ({
          value: permitType.id,
          label: permitType.work_permit_name,
        })
      );

      setPermitType(permitTypeOptions);
    } catch (error) {
      console.error("Error fetching customers data:", error.message);
    }
  };

  useEffect(() => {
    fetchPermitType();
  }, []);
  const handlePermitTypeChange = (selectedOption) => {
    setSelectedPermitType(selectedOption);
    setFormData((prevState) => ({
      ...prevState,
      permit_type_id: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleMethodChange = (selectedOption) => {
    setMethod(selectedOption ? selectedOption.value : "");
    setFormData((prevState) => ({
      ...prevState,
      method: selectedOption ? selectedOption.value : "",
    }));
  };
  const handleSaveClick = async () => {
    // Validate form data before sending the API request
    if (!formData.permit_type_id || !formData.method || !apiEndpoint) {
      setMessage("All fields are required");
      setSeverity("error");
      return;
    }

    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.post(
        `${API_URL}/api/add_permit_api_endpoint`,
        {
          permit_type_id: formData.permit_type_id,
          method: formData.method,
          api_endpoint: apiEndpoint,
        },
        {
          headers: {
            Authorization: authKey,
          },
        }
      );

      if (response.status === 201) {
        setMessage("Permit API endpoint added successfully");
        setSeverity("success");
        // Reset form
        setPermitTypeId("");
        setMethod("");
        setApiEndpoint("");
      }
    } catch (error) {
      setMessage("An error occurred while adding permit API endpoint");
      setSeverity("error");
      console.error("Error while saving:", error);
    }
  };
  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content">
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">Add Permit API Endpoint</PageBackTitle>
              <div className="data-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-form-body">
            {/* Form */}
            <form className="form-detail" onKeyDown={handleKeyDown}>
            <div className="new-data-form">
            <div className="form-group-select">
                  <label htmlFor="form_type">
                    Permit Type<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="form_type"
                    options={permitType}
                    value={selectedPermitType}
                    onChange={handlePermitTypeChange}
                    placeholder="Select permit type"
                  />
                </div>
        
                <div className="form-group-select">
                <label>Method:</label>
                <Select
                  id="method"
                  options={methodOptions}
                  value={methodOptions.find((option) => option.value === method)}
                  onChange={handleMethodChange}
                  placeholder="Select method"
                />
              </div>
              <div className="form-group">
                <label>API Endpoint:</label>
                <div className="input-group">
                <input
                  type="text"
                  value={apiEndpoint}
                  onChange={(e) => setApiEndpoint(e.target.value)}
                  required
                />
                   </div>
              </div>
              </div>
              
            </form>

            {/* Feedback Message */}

            <div className="footer">
              <div className="button-group">
                <button
                  className="data-form-save-button"
                  type="save"
                  onClick={handleSaveClick}
                //   disabled={isLoading}
                >
              Save
                </button>
                <button
                  className="data-form-cancel-button"
                //   onClick={handleCancelClick}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TemplateApiEndPoint;
